var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',{staticClass:"form-group mb-5"},[_c('legend',{class:'col-form-label pt-0 pb-3 font-weight-bold ' + _vm.labelClass},[_vm._v(_vm._s(_vm.label))]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }